// #

import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { DATES, DATES_ID } from 'services/constants/dates';
import { TGood } from './types';

export const tableStructure: TTableStructure<keyof TGood>[] = [
	{
		name: 'checkbox',
		selector: 'checkbox' as keyof TGood,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.CHECKBOX,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Good Id',
		selector: 'id' as keyof TGood,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'External Id',
		selector: 'externalId' as keyof TGood,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Shop Id',
		selector: 'shopId' as keyof TGood,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Good Name',
		selector: 'name' as keyof TGood,
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		filter: [['text']],
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created At',
		selector: 'createdAt' as keyof TGood,
		show: true,
		sortable: true,
		filterable: false,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt' as keyof TGood,
		show: true,
		sortable: true,
		filterable: false,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Good Type',
		selector: 'goodType' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['Good', 'Good'],
			['Tbe', 'Tbe'],
			['@empty', 'empty'],
		],
		colors: [
			['Good', 'success.light'],
			['Tbe', 'info.light'],
		],
	},
	{
		name: 'HS Code',
		selector: 'hsCode' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		searchable: true,
		filter: [['@empty', 'empty']],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Shop Type',
		selector: 'shopType' as keyof TGood,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'SKU',
		selector: 'sku' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		filter: [['@empty', 'empty']],
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Price',
		selector: 'price' as keyof TGood,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: (item: TGood) => {
			return item?.currency ?? 'EUR';
		},
	},
	{
		name: 'Currency',
		selector: 'currency' as keyof TGood,
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.CURRENCY,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Act as Disclosed Agent',
		selector: 'isActDisclosedAgent' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			['yes', 'yes'],
			['no', 'no'],
			['@empty', 'empty'],
		],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		colors: [
			['yes', 'success.light'],
			['no', 'error.light'],
		],
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Reduced VAT TBE',
		selector: 'isReducedVatTbe' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			['yes', 'yes'],
			['no', 'no'],
			['@empty', 'empty'],
		],
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colors: [
			['yes', 'success.light'],
			['no', 'error.light'],
		],
	},
	{
		name: 'Seller Registration Country',
		selector: 'sellerRegistrationCountry' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_NAME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Originating Country',
		selector: 'originatingCountry' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_NAME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Warehouse Location Country',
		selector: 'warehouseLocationCountry' as keyof TGood,
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_NAME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated By',
		selector: 'updatedByUser' as keyof TGood,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	// {
	// 	name: 'Actions',
	// 	selector: 'actions' as keyof TGood,
	// 	show: true,
	// 	sortable: false,
	// 	filterable: false,
	// 	colSpan: 1,
	// 	type: ETableStructureType.BUTTONS,
	// 	align: ETableStructureAlign.LEFT,
	// 	buttons: ['Download File'],
	// 	buttonFilter: (item: TGood) => {
	// 		switch (item.state !== 'ProductsMigrated') {
	// 			case true:
	// 				return [];
	// 			default:
	// 				return ['View Goods', 'Delete Shop'];
	// 		}
	// 	},
	// },
];
